var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("navbar"),
      _c("div", { class: [{ program: _vm.pageType === 1 }] }, [
        _c("div", { staticClass: "program-left" }, [
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("h2", { staticClass: "padding" }, [
                _vm._v(_vm._s(_vm.pageTitle)),
              ]),
              _c("basic-information", {
                ref: "basicInformation",
                attrs: { rQueryObj: _vm.rQuery, pDetails: _vm.details },
                on: { basicForm: _vm.resBasicForm },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("h3", [_vm._v(_vm._s(_vm.ruleTitle))]),
              _vm.pageType === 1
                ? _c("p", { staticClass: "size12 title_color" }, [
                    _vm._v("创建规则"),
                  ])
                : _vm._e(),
              _vm.pageType === 1
                ? _c("p", { staticClass: "size12" }, [
                    _vm._v(
                      "在全部用户中，将满足以下条件的用户分为 X 个分层，系统会按照以下自定义分层的顺序进行用户匹配，同一用户会被优先匹配在顺序靠前的分层中"
                    ),
                  ])
                : _vm._e(),
              _c("setup-rule", {
                ref: "setupRule",
                attrs: {
                  typeStr: _vm.pageType,
                  rQueryObj: _vm.rQuery,
                  pDetails: _vm.details,
                },
                on: { ruleForm: _vm.resRuleForm },
              }),
            ],
            1
          ),
        ]),
        _vm.pageType === 1
          ? _c("div", { staticClass: "program-right" }, [
              _c("div", { staticClass: "program-right-title" }, [
                _vm._v("预估人数"),
              ]),
              _c(
                "div",
                { staticClass: "program-right-select" },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择",
                        filterable: "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.estimateType,
                        callback: function ($$v) {
                          _vm.estimateType = $$v
                        },
                        expression: "estimateType",
                      },
                    },
                    _vm._l(_vm.dictionaries.tag_estimate_type, function (item) {
                      return _c("el-option", {
                        key: item.dictId,
                        attrs: { label: item.dictName, value: item.dictId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "program-right-button" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        plain: "",
                        loading: _vm.loading,
                      },
                      on: { click: () => _vm.submit("estimate") },
                    },
                    [_vm._v("预估")]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _c(
        "div",
        { staticClass: "operation-button" },
        [
          _vm.details.name
            ? _c(
                "el-button",
                {
                  attrs: { plain: "" },
                  on: { click: () => _vm.onMotivation("delete") },
                },
                [_vm._v("删除")]
              )
            : _vm._e(),
          _vm.details.status === 2
            ? _c(
                "el-button",
                {
                  attrs: { type: "success" },
                  on: { click: () => _vm.onMotivation("enable") },
                },
                [_vm._v("启动")]
              )
            : _vm._e(),
          _vm.details.status === 1
            ? _c(
                "el-button",
                {
                  attrs: { type: "success" },
                  on: { click: () => _vm.onMotivation("disable") },
                },
                [_vm._v("暂停")]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: () => _vm.onMotivation("submit") },
            },
            [_vm._v("提交")]
          ),
          _c(
            "el-button",
            {
              attrs: { plain: "" },
              on: { click: () => _vm.onMotivation("cancel") },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: _vm.dialog.width,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          [
            _c(
              "div",
              [
                _c(
                  "el-table",
                  {
                    staticClass: "estimate-data-list",
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.estimateDataList },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "tagTierName", label: "客户分层" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "预估人数/占比" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.customerCount)),
                              ]),
                              _c("span", [
                                _vm._v(
                                  "（" +
                                    _vm._s(
                                      scope.row.rate === "-"
                                        ? 0
                                        : scope.row.rate
                                    ) +
                                    "）"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }